import { OTLayout } from "@/components/layout/ot-layout";
import { CpdModuleReaderContent } from "@/components/cpd/cpd-module-reader";

export default function OTLearnModule() {
  return (
    <OTLayout title="CPD Learning Hub">
      <CpdModuleReaderContent listPath="/ot/learn" />
    </OTLayout>
  );
}
